import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=1302c156&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=1302c156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1302c156",
  null
  
)

export default component.exports